import Quill from 'quill';

const Inline = Quill.import('blots/inline');

class ContextLink extends Inline {
  static create(v) {
    let value = v;
    let node = super.create(value);
    value = value.trim();
    node.setAttribute('data-ref', value);
    node.setAttribute('href', '#');
    return node;
  }

  static formats(domNode) {
    return domNode.getAttribute('data-ref');
  }
}

ContextLink.blotName = 'context_link';
ContextLink.className = 'context-link';
ContextLink.tagName = 'a';

export default ContextLink;
